export const MAIN_CLASS_NAME = 'elma365-change-table';
export const SEARCH_CLASS_NAME = `${MAIN_CLASS_NAME}__search`;
export const CHECKBOX_CLASS_NAME = `${MAIN_CLASS_NAME}__checkbox`;
export const LABEL_CLASS_NAME = `${CHECKBOX_CLASS_NAME}__label`;
export const TOOLS_CLASS_NAME = `${MAIN_CLASS_NAME}__tools`;
export const TOOLS_ITEM_CLASS_NAME = `${TOOLS_CLASS_NAME}__item`;
export const DIFFS_CLASS_NAME = `${MAIN_CLASS_NAME}__diffs`;
export const DIFFS_ITEM_CLASS_NAME = `${DIFFS_CLASS_NAME}__item`;
